import service from '@/utils/request';

// 查询 天气 
export function getWeatherInfo() {
    return service.request({
        method: 'get',
        // url: `https://restapi.amap.com/v3/weather/weatherInfo?key=5f188a27d0f2b26ed95b5d4651034954&city=110101&extensions=base`,
        url: `http://wthrcdn.etouch.cn/weather_mini?city=成都`,
    })
}

// 后端 查询 天气 
export function apiGetWeather() {
    return service.request({
        method: 'POST',
        url: `/app/weather/getWeather`,
    })
}

export function getsysMessageList(param) {
    return service.request({
        method: 'POST',
        url: `/app/sysMessage/sysMessageList`,
        data: param
    })
}

// 消息列表 已读

export function readySysMessage(param) {
    return service.request({
        method: 'POST',
        url: `/app/sysMessage/edit`,
        data: param
    })
}



